import "antd/es/form/style";
import _Form from "antd/es/form";
var _excluded = ["validateMessages"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useRef, useContext } from 'react';
import FormContext from '../form-context';
import messages from './messages';
import './style/index.less';
import invariant from 'invariant';
import classNames from 'classnames';
import { LocaleContext } from '../locale';
import { getRuleValidation } from './../utils/form-utils';

var FreeForm = function FreeForm(props) {
  var children = props.children,
      onCancel = props.onCancel,
      onSubmit = props.onSubmit,
      className = props.className,
      style = props.style,
      _props$locales = props.locales,
      localesProp = _props$locales === void 0 ? {} : _props$locales,
      initialValues = props.initialValues,
      formProp = props.form,
      _props$requiredMark = props.requiredMark,
      requiredMark = _props$requiredMark === void 0 ? false : _props$requiredMark,
      _props$showSubmitButt = props.showSubmitButton,
      showSubmitButton = _props$showSubmitButt === void 0 ? true : _props$showSubmitButt,
      _props$getScrollConta = props.getScrollContainer,
      getScrollContainer = _props$getScrollConta === void 0 ? function () {
    return window;
  } : _props$getScrollConta,
      _props$onFirstModifie = props.onFirstModified,
      onFirstModified = _props$onFirstModifie === void 0 ? function () {} : _props$onFirstModifie,
      uploadApi = props.uploadApi,
      selectDatasourceApi = props.selectDatasourceApi,
      validationRule = props.validationRule,
      getRuleValidationApi = props.getRuleValidationApi;

  var _Form$useForm = _Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      innerForm = _Form$useForm2[0];

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      submitting = _useState2[0],
      setSubmitting = _useState2[1];

  var dependents = useRef({});

  var _useState3 = useState(formProp || innerForm),
      _useState4 = _slicedToArray(_useState3, 1),
      form = _useState4[0];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      firstModifiedCalled = _useState6[0],
      callFirstModified = _useState6[1];

  var _useContext = useContext(LocaleContext),
      currentLang = _useContext.currentLang;

  invariant(!validationRule || getRuleValidationApi, 'Please provide getRuleValidationApi in Form props');

  var validateMessages = localesProp.validateMessages,
      locales = _objectWithoutProperties(localesProp, _excluded);

  var handleSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(values) {
      var allValues, res, errors;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              allValues = form.getFieldsValue(true);
              setSubmitting(true);

              if (!(validationRule && getRuleValidationApi)) {
                _context.next = 18;
                break;
              }

              _context.prev = 3;
              _context.next = 6;
              return getRuleValidation(getRuleValidationApi, validationRule, allValues, currentLang);

            case 6:
              res = _context.sent;

              if (!(Array.isArray(res) && res.length)) {
                _context.next = 12;
                break;
              }

              form.setFields(res);
              form.scrollToField(res[0].name);
              setSubmitting(false);
              return _context.abrupt("return");

            case 12:
              _context.next = 18;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](3);
              setSubmitting(false);
              return _context.abrupt("return");

            case 18:
              if (!(typeof onSubmit === 'function')) {
                _context.next = 27;
                break;
              }

              _context.prev = 19;
              _context.next = 22;
              return onSubmit(values);

            case 22:
              errors = _context.sent;

              if (Array.isArray(errors)) {
                form.setFields(errors);
                form.scrollToField(errors[0].name);
              }

            case 24:
              _context.prev = 24;
              setSubmitting(false);
              return _context.finish(24);

            case 27:
              setSubmitting(false);

            case 28:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 14], [19,, 24, 27]]);
    }));

    return function handleSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var registerDependencies = function registerDependencies(field, updater) {
    if (Array.isArray(field)) {
      field.forEach(function (name) {
        var key = Array.isArray(name) ? name.join() : name;

        if (!dependents.current[key]) {
          dependents.current[key] = [];
        }

        dependents.current[key].push(updater);
      });
    }

    var key = Array.isArray(field) ? field.join() : field;

    if (!dependents.current[key]) {
      dependents.current[key] = [];
    }

    dependents.current[key].push(updater);
  };

  var handleValuesChange = function handleValuesChange(changedFields) {
    if (!firstModifiedCalled) {
      onFirstModified();
      callFirstModified(true);
    }

    if (!changedFields || !changedFields[0]) return;
    var changedField = changedFields[0].name;
    var changedKey = Array.isArray(changedField) ? changedField.join() : changedField;

    if (dependents.current[changedKey]) {
      dependents.current[changedKey].forEach(function (updater) {
        return updater();
      });
    }

    if (dependents.current['SUBSCRIBE_ALL']) {
      dependents.current['SUBSCRIBE_ALL'].forEach(function (updater) {
        return updater();
      });
    }
  };

  return _jsx("div", {
    className: classNames(className, {
      'igloo-freeform-without-button': !showSubmitButton
    }),
    style: style,
    children: _jsx(FormContext.Provider, {
      value: _objectSpread({
        form: form,
        onCancel: onCancel,
        submitting: submitting,
        requiredMark: requiredMark,
        showSubmitButton: showSubmitButton,
        getScrollContainer: getScrollContainer,
        registerDependencies: registerDependencies,
        uploadApi: uploadApi,
        selectDatasourceApi: selectDatasourceApi,
        getRuleValidationApi: getRuleValidationApi,
        handleValuesChange: handleValuesChange
      }, locales),
      children: _jsx(_Form, {
        form: form,
        onFinish: handleSubmit,
        onFieldsChange: handleValuesChange,
        colon: false,
        validateMessages: validateMessages || messages,
        initialValues: initialValues,
        scrollToFirstError: true,
        children: children
      })
    })
  });
};

FreeForm.useForm = _Form.useForm;
export default FreeForm;